"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PREFERENCES_LOAD_EMAIL = exports.NO_ALERT_SELECTED_VALUE_DISPLAY_NAME = exports.ALWAYS_VALUE_DISPLAY_NAME = exports.OFF_VALUE_DISPLAY_NAME = exports.ON_VALUE_DISPLAY_NAME = exports.PREFERENCES_UPDATE_SUB_CATEGORY = exports.PREFERENCES_FETCH_OPTIONS = exports.PREFERENCES_TOGGLE_ALL = exports.PREFERENCES_TOGGLE = exports.PREFERENCES_SAVE = exports.PREFERENCES_RESET = exports.PREFERENCES_LOAD = exports.PREFERENCES_FETCH = exports.PREFERENCES_CLEAR_ERROR = void 0;
const PREFERENCES_FETCH = 'preferences/FETCH';
exports.PREFERENCES_FETCH = PREFERENCES_FETCH;
const PREFERENCES_LOAD = 'preferences/LOAD';
exports.PREFERENCES_LOAD = PREFERENCES_LOAD;
const PREFERENCES_LOAD_EMAIL = 'preferences/LOAD_EMAIL';
exports.PREFERENCES_LOAD_EMAIL = PREFERENCES_LOAD_EMAIL;
const PREFERENCES_TOGGLE_ALL = 'preferences/TOGGLE_ALL';
exports.PREFERENCES_TOGGLE_ALL = PREFERENCES_TOGGLE_ALL;
const PREFERENCES_TOGGLE = 'preferences/TOGGLE';
exports.PREFERENCES_TOGGLE = PREFERENCES_TOGGLE;
const PREFERENCES_SAVE = 'preferences/SAVE';
exports.PREFERENCES_SAVE = PREFERENCES_SAVE;
const PREFERENCES_CLEAR_ERROR = 'preferences/CLEAR_ERROR';
exports.PREFERENCES_CLEAR_ERROR = PREFERENCES_CLEAR_ERROR;
const PREFERENCES_RESET = 'preferences/RESET';
exports.PREFERENCES_RESET = PREFERENCES_RESET;
const PREFERENCES_FETCH_OPTIONS = 'preferences/FETCH_OPTIONS';
exports.PREFERENCES_FETCH_OPTIONS = PREFERENCES_FETCH_OPTIONS;
const PREFERENCES_UPDATE_SUB_CATEGORY = 'preferences/PREFERENCES_UPDATE_SUB_CATEGORY';
exports.PREFERENCES_UPDATE_SUB_CATEGORY = PREFERENCES_UPDATE_SUB_CATEGORY;
const ON_VALUE_DISPLAY_NAME = 'on';
exports.ON_VALUE_DISPLAY_NAME = ON_VALUE_DISPLAY_NAME;
const OFF_VALUE_DISPLAY_NAME = 'off';
exports.OFF_VALUE_DISPLAY_NAME = OFF_VALUE_DISPLAY_NAME;
const ALWAYS_VALUE_DISPLAY_NAME = 'Always';
exports.ALWAYS_VALUE_DISPLAY_NAME = ALWAYS_VALUE_DISPLAY_NAME;
const NO_ALERT_SELECTED_VALUE_DISPLAY_NAME = 'No Alert Selected';
exports.NO_ALERT_SELECTED_VALUE_DISPLAY_NAME = NO_ALERT_SELECTED_VALUE_DISPLAY_NAME;
//# sourceMappingURL=index.js.map